var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.555664,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#3CC7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9904 12.0345C28.1227 12.2424 27.8961 12.4846 27.6558 12.43C27.1858 12.29 26.6658 12.22 26.1358 12.22H22.8355C22.6782 12.22 22.5302 12.1461 22.4357 12.0204L21.2858 10.49C21.1449 10.2904 21.278 10 21.5223 10H24.2758C25.8368 10 27.2118 10.8107 27.9904 12.0345Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6957 14.54C28.2657 14.23 27.7757 14 27.2457 13.87C26.8857 13.77 26.5157 13.72 26.1357 13.72H22.4157C21.8357 13.72 21.7957 13.67 21.4857 13.26L20.0857 11.4C19.4357 10.53 18.9257 10 17.2957 10H14.9757C12.5357 10 10.5557 11.98 10.5557 14.42V25.58C10.5557 28.02 12.5357 30 14.9757 30H26.1357C28.5757 30 30.5557 28.02 30.5557 25.58V18.14C30.5557 16.65 29.8257 15.34 28.6957 14.54ZM22.9457 24.34H18.1557C17.7657 24.34 17.4657 24.03 17.4657 23.64C17.4657 23.26 17.7657 22.94 18.1557 22.94H22.9457C23.3357 22.94 23.6457 23.26 23.6457 23.64C23.6457 24.03 23.3357 24.34 22.9457 24.34Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountFile);
export default __webpack_public_path__ + "static/media/count_file.646fafe3d7dc34ebd9c4261d75b9c9e5.svg";
export { ForwardRef as ReactComponent };